import * as api from '../../../requests'
import { ADD_PDF_TO_LIST, pdfTypes } from '../../ReportViewer/ReportViewerReducer'
import {
  SET_BATCH_TYPES,
  SET_PAYMENTS,
  SET_REPORTS,
  SET_BATCH_NUM,
} from './PostDistributionReducer'

export const GetBatchTypes = () => {
  return (dispatch) => {
    api.GET_BATCH_TYPES((response) => {
      dispatch(
        {
          type: SET_BATCH_TYPES,
          batchTypes: response.map((batchType) => {
            return { label: batchType.name, value: batchType.id }
          }),
        },
        (err) => {
          console.error(err)
        }
      )
    })
  }
}

export const GetPostDistributions = (type, throughDate) => {
  return (dispatch) => {
    api.GET_DIST_PAYMETS(
      type,
      throughDate.replaceAll('/', '-'),
      (response) => {
        dispatch({ type: SET_PAYMENTS, payments: response })
      },
      (err) => {
        console.error(err)
      }
    )
  }
}

export const GetReports = () => {
  return (dispatch) => {
    api.GET_DIST_REPORTS(
      (response) => {
        dispatch({ type: SET_REPORTS, reports: response })
      },
      (err) => {
        console.error(err)
      }
    )
  }
}

export const Post = (batchType, closeDate) => {
  return (dispatch) => {
    api.POST_DIST(
      batchType,
      closeDate.replaceAll('/', '-'),
      (response) => {
        dispatch({ type: SET_BATCH_NUM, batchNum: response })
      },
      (err) => {
        console.error(err)
      }
    )
  }
}

export const GetDistReports = (batchNum) => {
  return (dispatch) => {
    dispatch({
      type: ADD_PDF_TO_LIST,
      pdfInfo: {
        filename: `DistReport_${batchNum}.pdf`,
        type: pdfTypes.DISTRIBUTION_REPORT,
        batchNum: batchNum,
      },
    })
  }
}
